import React from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { usePageTracking } from '../../hooks/usePageTracking';

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  useScrollToTop();
  usePageTracking();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
      <Header />
      {children}
      <Footer />
    </div>
  );
}